"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
require("./Input.scss");
var _reactIcons = require("@radix-ui/react-icons");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Input = function Input(_ref) {
  var pattern = _ref.pattern,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? "First name" : _ref$label,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? "Enter first name" : _ref$placeholder,
    _ref$errormsg = _ref.errormsg,
    errormsg = _ref$errormsg === void 0 ? "Invalid format." : _ref$errormsg,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? "text" : _ref$type,
    value = _ref.value,
    onChange = _ref.onChange,
    className = _ref.className,
    disabled = _ref.disabled,
    onClick = _ref.onClick,
    validation = _ref.validation,
    name = _ref.name,
    fluid = _ref.fluid;
  var isSearchInput = type === "search";
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "inputfield ".concat(isSearchInput ? "inputSearch" : "", " ").concat(fluid ? "fluid" : "", " ").concat(className || ""),
    disabled: disabled
  }, isSearchInput && /*#__PURE__*/_react["default"].createElement(_reactIcons.MagnifyingGlassIcon, null), /*#__PURE__*/_react["default"].createElement("input", {
    pattern: pattern,
    type: type,
    placeholder: placeholder,
    value: value,
    onChange: onChange,
    onClick: onClick,
    name: name
  }), type !== "number" && /*#__PURE__*/_react["default"].createElement("label", null, label), errormsg !== false && /*#__PURE__*/_react["default"].createElement("p", null, errormsg), type !== "number" && type !== "date" && validation !== false && /*#__PURE__*/_react["default"].createElement("span", null));
};
var _default = exports["default"] = Input;